import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, enableIndexedDbPersistence } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';

// YOUR Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA-baMsbfDJPViAeAp2Ls4nydeuHUXrxT4",
  authDomain: "band-dad.firebaseapp.com",
  projectId: "band-dad",
  storageBucket: "band-dad.firebasestorage.app",
  messagingSenderId: "429724307404",
  appId: "1:429724307404:web:b911a606a6b447d7809769",
  measurementId: "G-PT4JPDJ8K8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize App Check immediately
// if (window.location.hostname !== 'localhost') {
//   initializeAppCheck(app, {
//     provider: new ReCaptchaEnterpriseProvider('6LfMoyMsAAAAAMO9-xpBf9EhIzcjEcQ9BT9PuA4J'),
//     isTokenAutoRefreshEnabled: true
//   });
// }
// Initialize Authentication, Firestore, and Storage
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Enable offline persistence
enableIndexedDbPersistence(db)
  .then(() => {
    console.log('Offline persistence enabled');
  })
  .catch((err) => {
    if (err.code === 'failed-precondition') {
      // Multiple tabs open, persistence can only be enabled in one tab at a time
      console.warn('Offline persistence unavailable: multiple tabs open');
    } else if (err.code === 'unimplemented') {
      // Browser doesn't support persistence
      console.warn('Offline persistence not supported in this browser');
    }
  });

export default app;